import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

const ContentHalves = styled.div`
  ${media.moreThan('smPlus')`
    display: flex;
    margin-left: -40px;

    > div {
      flex: 0 1 50%;
      margin-left: 40px;
    }
  `};
`;

export default ContentHalves;
